export const INJECT_PORTAL_CONTEXT = 'uicore:portalContext';
//# sourceMappingURL=consts.js.map
